/** Event dates are calendar dates; UTC date-only values must not move a day. */
export const formatShowDate = (value?: string, asTimestamp = false) => {
  if (!value) return 'Not scheduled';
  const date = new Date(value);
  const calendarDate = !asTimestamp && /^\d{4}-\d{2}-\d{2}(?:T00:00:00(?:\.000)?Z)?$/.test(value);
  return Number.isNaN(date.getTime())
    ? value
    : date.toLocaleDateString(undefined, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        ...(calendarDate ? { timeZone: 'UTC' } : {})
      });
};
